export enum SourceType {
    MyFavorites = "MY_FAVORITES",
    RecentlyWatched = "RECENTLY_WATCHED",
    Standard = "STANDARD"
}